<template>
  <div class="bed-eoc-container p-3 d-flex flex-column">
    <div class="d-flex justify-content-between align-items-center">
      <div class="bed-name">
        {{ bed.name }}
      </div>
      <img
        class="bed-unassign"
        :src="require('../assets/icons/close-circle.png')"
        @click="$emit('unassign')"
      />
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="patient-name">
        {{ eoc.patient | formatClient }}
      </div>
      <div class="eoc-status">
        <eoc-status-badge :status="eoc.status" />
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="eoc-mrn">
        {{ { mrn: eoc.patient.mrn, eocn: eoc.eocn } | formatMrn }}
      </div>
      <eoc-loc-badge :levelOfCare="eoc.levelOfCare" />
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="patient-gender">
        {{ (eoc.patient.gender || {}).name || "" }}
      </div>
      <div class="eoc-date">Start: {{ eoc.startDate | formatDateOnly }}</div>
    </div>
  </div>
</template>

<script>
import EocStatusBadge from "./EocStatusBadge.vue";
import EocLocBadge from "./EocLocBadge.vue";

export default {
  name: "BedEocTemplate",
  components: { EocStatusBadge, EocLocBadge },
  props: ["bed", "eoc"]
};
</script>

<style lang="scss">
.bed-eoc-container {
  position: relative;
  gap: 4px;
  font-size: 0.9rem;

  .bed-name {
    font-size: 1rem;
    font-weight: bold;
    line-height: 1.35;
  }

  .bed-unassign {
    position: absolute;
    top: 6px;
    right: 6px;
  }
  .bed-unassign:hover {
    cursor: pointer;
  }

  .patient-gender {
    text-transform: uppercase;
  }
}
</style>
